import i18n from "@/i18n";

type Rule = [RegExp, string, string[]?];

const rules: Rule[] = [
  [/^Could not store file: (.*)$/, "_p.storeFail", ["reason"]],
  [/^(\S+) is required\.?$/, "_p.required", ["field"]],
  [/^(\S+) must be a valid email address$/, "_p.validEmail", ["field"]],
  [/^(\S+) must be a non-negative number$/, "_p.nonNegNumber", ["field"]],
  [/^(\S+) must be a non-negative integer$/, "_p.nonNegInt", ["field"]],
  [/^(\S+) must be a hex color like #1A2B3C$/, "_p.hexColor", ["field"]],
  [/^(.+) must be a valid date\.?$/, "_p.validDate", ["field"]],
  [/^(.+) is too long$/, "_p.tooLong", ["field"]],
  [/^(.+) must be one of the listed choices\.$/, "_p.listedChoice", ["field"]],
  [/^(\S+) must be one of:? (.+?)\.?$/, "_p.oneOf", ["field", "list"]],
  [/^Student limit reached \((\d+)\/(\d+)\)$/, "_p.studentLimit", ["current", "max"]],
  [/^Campus limit reached \((\d+)\/(\d+)\)$/, "_p.campusLimit", ["current", "max"]],
  [/^Institution limit reached \((\d+)\/(\d+)\)$/, "_p.institutionLimit", ["current", "max"]],
  [/^Credential user limit reached \((\d+)\/(\d+)\)$/, "_p.credentialLimit", ["current", "max"]],
  [/^Account temporarily locked due to too many failed login attempts\. Try again in (\d+) minute\(s\)\.$/, "_p.locked", ["minutes"]],
  [/^CORS blocked origin: (.*)$/, "_p.cors", ["origin"]],
  [/^That page is too far down the list — narrow it with a search, class or status filter \(limit (\d+) rows\)\.$/, "_p.pageTooFar", ["limit"]],
  [/^This group still has (\d+) child node\(s\) — delete those first$/, "_p.childNodes", ["count"]],
  [/^This teacher is already the class teacher of academic group (\d+)$/, "_p.alreadyClassTeacher", ["id"]],
  [/^This teacher is the permanent class teacher of academic group (\d+) and cannot substitute elsewhere$/, "_p.permanentClassTeacher", ["id"]],
  [/^This teacher is already substituting for academic group (\d+) on this date$/, "_p.alreadySubstituting", ["id"]],
  [/^This institution already has an academic structure \((\d+) groups\) — applying a template merges into it .*$/, "_p.structureExists", ["count"]],
  [/^This template has been applied by (\d+) institution\(s\) and cannot be deleted$/, "_p.templateApplied", ["count"]],
  [/^subjectId (\S+) not found in the master catalog$/, "_p.subjectNotInCatalog", ["id"]],
  [/^The file must be sent under the field name "(.+)", not "(.*)"\.$/, "_p.fileField", ["expected", "actual"]],
  [/^Unexpected form field\. The file must be sent under the field name "(.+)", not "(.*)"\.$/, "_p.fileField", ["expected", "actual"]],
  [/^No file received \(field name must be "(.+)"\)$/, "_p.noFile", ["field"]],
  [/^This class only runs (\d+) periods? on that day — that period doesn't exist for it\.$/, "_p.noSuchPeriod", ["limit"]],
  [/^That day isn't a working day for this class \(it runs (.+)\)\. Change the class's working days first if it should run then\.$/, "_p.notWorkingDay", ["days"]],
  [/^Some subjects need a room from a group that has no active room: (.+)\. Add a room to the group, or remove the requirement from the subject\.$/, "_p.noActiveRoom", ["groups"]],
  [/^Not enough weekly slots for: (.+)\. Lower a subject's periods\/week, remove a pinned\/locked period, or add a working day\/period\.$/, "_p.notEnoughSlots", ["summary"]],
  [/^Too much load for: (.+)\. Add another eligible teacher for those subjects or lower their periods\/week\.$/, "_p.tooMuchLoad", ["summary"]],
  [/^This institution has used all (\d+) of its auto-generates for this academic year\. Contact your super admin to raise the limit\.$/, "_p.autoGenUsed", ["limit"]],
  [/^This institution has used all (\d+) of its auto-generate confirmations for this academic year — contact your super admin to raise the limit$/, "_p.autoGenUsed", ["limit"]],
  [/^establishedYear must be a valid year between 1800 and (\d+)$/, "_p.establishedYear", ["year"]],
  [/^Template (\S+) does not exist$/, "_p.templateMissing", ["id"]],
  [/^Institution (\S+) does not belong to this (.+)$/, "_p.institutionNotBelong", ["id", "owner"]],
  [/^Unknown or non-assignable modules: (.+)$/, "_p.unknownModules", ["list"]],
  [/^Not allowed by the organization: (.+)$/, "_p.notAllowedByOrg", ["list"]],
  [/^This role is still assigned to (\d+) staff\/login\(s\) — reassign (?:or deactivate )?them before deleting it\.$/, "_p.roleAssigned", ["count"]],
  [/^This subject is attached to (\d+) academic group\(s\) — remove those attachments first, or deactivate the subject instead of deleting it\.$/, "_p.subjectAttached", ["count"]],
  [/^Cannot import more than (\d+) rows at once\.$/, "_p.maxRows", ["max"]],
  [/^endDate must be after the current end date \((.+)\)$/, "_p.endAfterCurrent", ["date"]],
  [/^endDate must be after the start date \((.+)\)$/, "_p.endAfterStart", ["date"]],
  [/^(.+) is a school holiday \((.+)\)\.$/, "_p.holiday", ["date", "label"]],
  [/^Only (\d+) of "(.+)" left in stock$/, "_p.onlyLeft", ["left", "name"]],
  [/^You can order at most (\d+) of "(.+)" at a time$/, "_p.orderAtMost", ["limit", "name"]],
  [/^Enter marks for every student before submitting \((\d+) still missing\)$/, "_p.marksMissing", ["count"]],
  [/^Marks must be between 0 and (\S+)$/, "_p.marksBetween", ["max"]],
  [/^This room seats (\d+) but the class has (\d+) students$/, "_p.roomSeats", ["capacity", "students"]],
  [/^This class already has a paper at an overlapping time: (.+)$/, "_p.paperOverlap", ["paper"]],
  [/^That date is outside the academic year \((.+) to (.+)\)$/, "_p.outsideYear", ["start", "end"]],
  [/^Leave can start at most (\d+) days? in the past$/, "_p.leaveBackdate", ["days"]],
  [/^A medical certificate is required for sick leave longer than (\d+) days?$/, "_p.medicalCert", ["days"]],
  [/^A leave request can cover at most (\d+) days — please split it$/, "_p.leaveMaxDays", ["days"]],
  [/^Your leave request was (approved|rejected)$/, "_p.leaveDecision", ["status"]],
  [/^Academic structure request (approved|rejected)$/, "_p.structureDecision", ["status"]],
];

export const serverMsg = (key: string, fallback: string) => i18n.t(key, { ns: "serverErrors", nsSeparator: false, keySeparator: false, defaultValue: fallback });

const decided = new Set(["approved", "rejected"]);

export function translateServerError(msg: string): string {
  if (!msg) return msg;
  const opts = { ns: "serverErrors", nsSeparator: false, keySeparator: false } as const;
  if (i18n.exists(msg, opts)) return i18n.t(msg, opts);
  for (const [re, key, names = []] of rules) {
    const m = msg.match(re);
    if (!m) continue;
    const params: Record<string, string> = {};
    names.forEach((n, i) => {
      const v = m[i + 1];
      params[n] = n === "status" && decided.has(v) ? i18n.t(`_p.${v}`, { ...opts, defaultValue: v }) : v;
    });
    if (i18n.exists(key, opts)) return i18n.t(key, { ...opts, ...params });
  }
  return msg;
}

export const serverLabel = (text: string): string => (text ? i18n.t(text, { ns: "serverLabels", nsSeparator: false, keySeparator: false, defaultValue: text }) : text);
